import { useMemo } from 'react';
import { GoogleOutlined } from '@ant-design/icons';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/modules/ui';

import { composeSignInUrl } from '../../services/oauth/composeSignInUrl';
import { useHandleOAuthResult } from './hooks/useHandleOAuthResult';
import { container } from './LoginButton.rules';

export const LoginButton = () => {
    const { css } = useFela();
    const signInUrl = useMemo(() => composeSignInUrl(), []);
    const oauthResult = useHandleOAuthResult();

    return (
        <div className={css(container)}>
            <Button
                type='primary'
                icon={<GoogleOutlined />}
                href={signInUrl}
                target='_self'
                rel='noopener noreferrer'
                loading={oauthResult.isLoading}
            >
                <FormattedMessage id='auth.login.button.google' />
            </Button>
        </div>
    );
};
